<template>
    <div>
        <div class="container backgroundWhite">
            <h1 class="backgroundBlack">Portfolio</h1>
            <div style="min-height: 100vh">
                <div id="gridPhoto" class="row no-gutters none">
                    <div class="col-lg-4 BackImgOne">
                        <a href="/#/svatba"><img class="img-fluid"
                                                                              src="../assets/smallShadow1.png"
                                                                              alt="wedding"></a>
                    </div>
                    <div class="col-lg-8 BackImgTwo">
                        <a href="/#/portrety"><img class="img-fluid" src="../assets/smallShadowPortret1.png"
                                                           alt="picture"></a>
                    </div>
                    <div class="w-100"></div>
                    <div class="col-lg-8 BackImgThree">
                        <a href="/#/reportaz"> <img class="img-fluid" src="../assets/smallShadowReport1.png"
                                                            alt="report"></a>
                    </div>
                    <div class="col-lg-4 BackImgFour">
                        <a href="/#/miminka"><img class="img-fluid" src="../assets/smallShadowMimi1.png"
                                                           alt="baby"></a>
                    </div>
                    <div class="w-100"></div>
                    <div class="col-lg-4 BackImgFive">
                        <a href="/#/divadlo"><img id="GridImgTheatre" class="img-fluid" src="../assets/smallShadowTheatre1.png"
                                                           alt="theatre"></a>
                    </div>
                    <div class="col-lg-8 BackImgSix">
                        <a href="/#/rodina"><img class="img-fluid" src="../assets/smallShadowFamily1.png"
                                                           alt="family"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "gridPhoto",
        components: {},
        data() {
            return {
                counter: 0
            }
        },
        created() {
            let counter = 0;
            window.addEventListener("scroll", function () {
                let scroll = this.scrollY;
                console.log(scroll);
                if (scroll > 100) {
                    document.getElementById('top-navbar').classList.add('black');
                } else {
                    document.getElementById('top-navbar').classList.remove('black');
                }
                if (counter < 1) {
                    if (scroll > 1000) {
                        document.getElementById('gridPhoto').classList.remove('none');
                    }
                    else {
                        document.getElementById('gridPhoto').classList.add('none')
                    }
                }
                if (scroll > 1270) {
                    document.getElementById('top-navbar').classList.add('hide');
                } else {
                    document.getElementById('top-navbar').classList.remove("hide");
                }
                if (scroll > 2100) {
                    counter++
                }

            });
        },
        methods: {}
    }
</script>

<style scoped>
    .none {
        display: none;
    }

    h1 {
        padding-bottom: 0.5rem;
        padding-left: 15px;
        color: white;
        padding-top: 10px;
        font-size: 3.5rem;
    }

    .backgroundWhite {
        background-color: white;
    }

    .backgroundBlack {
        background-color: black;
    }

    .BackImgOne {
        background-image: url("../assets/svatba.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        animation: leftMove 1s forwards ease-out;
        border: solid 1px white;
    }

    .BackImgTwo {
        background-image: url("../assets/portret.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        animation: rightMove 1s forwards ease-out;
        border: solid 1px white;
    }

    .BackImgThree {
        background-image: url("../assets/report.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        animation: leftMove 1.5s forwards ease-out;
        border: solid 1px white;
    }

    .BackImgFour {
        background-image: url("../assets/mimi.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        animation: rightMove 1.5s forwards ease-out;
        border: solid 1px white;
    }

    .BackImgFive {
        background-image: url("../assets/divadlo.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        animation: leftMove 2s forwards ease-out;
        border: solid 1px white;
    }
    .BackImgSix {
        background-image: url("../assets/rodina.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        animation: rightMove 2s forwards ease-out;
        border: solid 1px white;
    }
    /*RESPONSIVE ANIMATION GRID UNDER 992*/
    @media screen and (max-width: 992px) {
        .BackImgOne,
        .BackImgTwo,
        .BackImgThree,
        .BackImgFour,
        .BackImgFive,
        .BackImgSix{
            animation: none;
        }
    }
    .img-fluid {

    }

    .img-fluid:hover {
        animation: animationGrid 0.4s ease-out forwards;
    }

    @keyframes animationGrid {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes leftMove {
        0% {
            transform: translateX(-1000px);
        }
        100% {
            transform: translate(0px);
        }
    }

    @keyframes rightMove {
        0% {
            transform: translateX(1000px);
        }
        100% {
            transform: translate(0px);
        }
    }

</style>